import type * as ents from '@attain-apps/entities'
import type * as chartJs from 'chart.js'

import * as color from '../../../../../color'
import * as utils from '../utils'

/**
 * Transform data from
 * {@link ents.core.display.Chart.Options<ents.core.display.chart.Type.DonutChart>} to
 * {@link chartJs.ChartOptions<'doughnut'>}
 */
export function getOptions({
  config = {},
  data,
}: ents.core.display.chart.Chart<ents.core.display.chart.Type.Donut>): chartJs.ChartOptions<'doughnut'> {
  const { cutout, displayLegend = false, name, onItemClick } = config
  let options: chartJs.ChartOptions<'doughnut'> = {
    ...utils.DEFAULT_OPTIONS,
    cutout: cutout?.percent,
    plugins: {
      legend: {
        display: displayLegend,
      },
      tooltip: {
        displayColors: data?.slices
          ? utils.getUniqueDatasetNames(data.slices).size > 1
          : false,
      },
    },
    scales: {
      x: {
        display: false,
      },
      y: {
        display: false,
      },
    },
  }
  /**
   * Will be equal to {@link name} if available; otherwise, it defaults to
   * {@link data.name}. If neither is defined, `undefined` is assigned.
   */
  const chartTitle = name ?? data?.name
  if (chartTitle) {
    options = {
      ...options,
      plugins: {
        ...options.plugins,
        title: {
          align: 'center',
          color: color.BLACK,
          display: true,
          font: {
            weight: 'bold',
          },
          padding: {
            bottom: 20,
          },
          text: chartTitle,
        },
      },
    }
  }
  if (data && onItemClick) {
    options = {
      ...options,
      onClick(_, elements) {
        const slice = utils.getSliceByIndex(data, elements)
        if (slice) {
          onItemClick(slice)
        }
      },
      onHover: (_, elements, chart) => {
        // Change cursor to pointer if hovering over a slice
        chart.canvas.style.cursor = elements.length ? 'pointer' : 'default'
      },
    }
  }
  return options
}
